import LOCALS from 'commons/locals';
import { FormLabel } from '../../form-label';
import i18n from 'i18n';
import { LANG_LIST } from 'pages/product/create-page-v2/common';
import { Input, Tag } from 'antd';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useAppSelector } from 'store/hooks';
import classNames from 'classnames';
import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';

const ProductName = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  const { language } = useAppSelector(selectGlobalInfo);

  return (
    <div className="flex gap-2">
      <FormLabel required>{i18n.t(LOCALS.product_name)}:</FormLabel>

      <div className="relative w-full">
        <div className="items-center w-full grid grid-cols-2 gap-y-3 gap-x-8 bg-gray-200 p-3 rounded-md">
          {LANG_LIST.map((lang) => {
            return (
              <div key={lang} className="flex gap-1">
                <Tag
                  color={lang === language ? '#1677ff' : 'default'}
                  className={classNames(
                    'flex items-center justify-center mx-0',
                    language === 'en' ? 'w-40' : 'w-[120px]'
                  )}
                >
                  {i18n.t(lang)}
                </Tag>

                <Controller
                  name={`productList.${index}.name.${lang}`}
                  control={control}
                  render={({ field, fieldState }) => {
                    return (
                      <Input
                        {...field}
                        status={fieldState.error ? 'error' : undefined}
                        placeholder={i18n.t(LOCALS.please_enter) || ''}
                        onChange={(e) => {
                          field.onChange(e);
                        }}
                      />
                    );
                  }}
                ></Controller>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductName;
